// Maxin to handle pop-ups including tips and rate us. It shows one pop-up upon opening the app, but ensures that no pop-up would show in short interval, + no duplications

import Vue from 'vue';
import RateUsDialog from '@/components/RateUsDialog';
import LanguageSelectModal from '@/components/LanguageSelectModal';
import popupLock from '@/popupLock';
import { i18n, languageHasBeenSet } from '@/i18n';

export default {
  methods: {
    showTipsDialog({ force = false, tipIndex = null } = {}) {
      let that = this;
      let tipIdShownSoFar = parseInt(window.localStorage.getItem('tip_id_shown_so_far') || 0); // tip id always = tip index + 1
      if (tipIndex === null) { tipIndex = tipIdShownSoFar; }
      let stopTips = !!parseInt(window.localStorage.getItem('stop_tips') || 0);
      let buttonLabels = [i18n.t("ui.close"), i18n.t("ui.not_again"), i18n.t("tips.next")];
      let callback = (response) => {
        if (!response) { return; }
        if (response === 1) {
          window.localStorage.setItem('stop_tips', 1);
          return;
        }
        if (response === 2) {
          that.showTipsDialog({ force: true, tipIndex: tipIndex+1 });
          return;
        }
      };
      let tips = [
        () => { // tip #1
          if (!that.$isCordova && typeof window.orientation === 'undefined') {
            return callback(2);
          }
          let tipImgUrl = require('@/assets/img/tip1.png');
          that.$ons.notification.confirm({
            title: i18n.t("tips.tip1_title"),
            messageHTML: `<img src="${tipImgUrl}"></img>`,
            buttonLabels: buttonLabels,
          }).then(callback);
        },
        // () => { // tip #2
        //   that.$ons.notification.confirm('Are you ready 2?', {
        //     title: 'Did you know? Tip #2',
        //     buttonLabels: buttonLabels,
        //   }).then(callback);
        // },
      ];
      if (tipIndex >= tips.length) { return; }
      if (tipIndex === tips.length - 1) { buttonLabels = [i18n.t("ui.close"), i18n.t("ui.not_again")]; }
      if (!force) {
        if (stopTips) { return; }
        if (popupLock.isLocked()) { return; }
      }
      popupLock.set();
      window.localStorage.setItem('tip_id_shown_so_far', tipIndex+1);
      tips[tipIndex]();
    },
    showRateAppDialog({ force = false } = {}) {
      if (!this.$isCordova) { return; }
      let stopRateApp = !!parseInt(window.localStorage.getItem('stop_rate_app') || 0);
      if (!force) {
        if (this.$firstRun) { return; }
        if (stopRateApp) { return; }
        if (popupLock.isLocked()) { return; }
      }
      popupLock.set();
      window.localStorage.setItem('stop_rate_app', 1);
      const RateUsDialogC = Vue.extend({ ...RateUsDialog, i18n });
      let instance = new RateUsDialogC();
      instance.$mount();
      document.body.appendChild(instance.$el);
    },
    showLanguageSelectModal({ force = false } = {}) {
      const uiLanguageSet = languageHasBeenSet();
      if (!force) {
        if (uiLanguageSet) {
          return Promise.resolve(true);
        }
      }

      return new Promise((resolve, reject) => {
        const LanguageSelectModalC = Vue.extend({ ...LanguageSelectModal, i18n });
        let instance = new LanguageSelectModalC({
          propsData: {
            doneCallback: () => {
              resolve(true);
            }
          }
        });
        instance.$mount();
        document.body.appendChild(instance.$el);
      });
    },
  },
};
